import React from "react";
import productBags from "../assets/product-bags.jpeg";

const byproducts = [
  { name: "Ferrous Sulphate", grade: "Heptahydrate Grade", value: "45,000 TPA" },
  { name: "Magnesium Sulphate", grade: "Technical Grade", value: "48,000 TPA" },
  { name: "Iron Oxide", grade: "Pigment Grade", value: "750 TPA" },
];

export default function ProductsSection() {
  return (
    <section className="bg-foreground px-6 py-20 text-background" id="products">
      <div className="mx-auto max-w-screen-xl">
        <div className="grid grid-cols-1 gap-20 md:grid-cols-2">
          <div>
            <div className="mb-6 inline-block border border-background/20 px-3 py-1">
              <span className="font-mono text-[11px] uppercase tracking-[0.2em]">
                Primary Output
              </span>
            </div>
            <h2 className="mb-8 text-5xl font-bold tracking-tight">
              VELOX Titanium Dioxide
            </h2>
            <p className="mb-12 text-lg text-background/60">
              Anatase Grade TiO2 with superior brightness and dispersion properties
              for the coatings, plastics, and paper industries.
            </p>
            <div className="border border-background/10 bg-background/5 p-8">
              <img
                alt="Stacked VELOX titanium dioxide bags on a pallet"
                className="mb-6 aspect-[3/2] w-full object-cover outline-1 -outline-offset-1 outline-background/10"
                height="800"
                width="1200"
                loading="lazy"
                src={productBags}
              />
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs">ISO 9001:2015</span>
                <span className="font-mono text-xs text-accent">
                  SPEC_SHEET_01.PDF
                </span>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-end">
            <h3 className="mb-8 border-b border-background/10 pb-4 font-mono text-[11spx] uppercase tracking-widest text-background/40">
              Industrial Byproducts
            </h3>
            <div className="space-y-6">
              {byproducts.map((bp) => (
                <div
                  key={bp.name}
                  className="flex items-end justify-between border-b border-background/10 pb-4"
                >
                  <div>
                    <h4 className="text-xl font-bold uppercase tracking-tighter">
                      {bp.name}
                    </h4>
                    <span className="text-xs text-background/40">{bp.grade}</span>
                  </div>
                  <span className="font-mono text-sm">{bp.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
